import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { CAT_ILLUSTRATION_PATH } from "../constants";

export const BrowseEmptyState: FC = () => (
  <Col alignItems="center" padding={{ top: "S500", bottom: "S500" }}>
    <img src={CAT_ILLUSTRATION_PATH} alt="" width={247} height={200} />
    <Text fontSize="T200" color="var(--st-dt-color-text-secondary)" textAlign="center" margin={{ top: "S300" }}>
      {getString("useCases.browsePage.emptyStateMessage")}
    </Text>
  </Col>
);
